export enum RateQuoteAcceptanceExceptionReason {
  INACTIVE = 'INACTIVE',
  ERRORED = 'ERRORED',
}
